import type { PromotionLink, TeamMember } from '@/domain/affiliate/Affiliate'
import type { AffiliateRepository } from '@/domain/affiliate/AffiliateRepository'
import type { PerformanceRepository } from '@/domain/performance/PerformanceRepository'
import type { AgentId } from '@/domain/shared/Brand'
import type { AffiliateService, TeamSummary } from './AffiliateService'

/**
 * 分销业务应用服务，负责数据链路编排
 */
export class DefaultAffiliateService implements AffiliateService {
  constructor(
    private readonly affiliateRepository: AffiliateRepository,
    private readonly performanceRepository: PerformanceRepository,
  ) {}

  async getPromotionLink(agentId: AgentId): Promise<PromotionLink> {
    return this.affiliateRepository.getPromotionLink(agentId)
  }

  async getTeamSummary(agentId: AgentId): Promise<TeamSummary> {
    const [totalCount, recentMembers] = await Promise.all([
      this.performanceRepository.getConsumersCount(agentId),
      this.getRecentlyJoinedMembers(agentId),
    ])

    return {
      totalCount,
      recentMembers,
    }
  }

  async getRecentlyJoinedMembers(agentId: AgentId): Promise<TeamMember[]> {
    return this.affiliateRepository.getRecentlyJoinedMembers(agentId)
  }
}
